var _path, _path2, _rect, _rect2, _g, _path3, _path4, _rect3, _rect4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45C34.9264 45 45 34.9264 45 22.5ZM3.75 22.5C3.75 12.1447 12.1447 3.75 22.5 3.75C32.8553 3.75 41.25 12.1447 41.25 22.5C41.25 32.8553 32.8553 41.25 22.5 41.25C12.1447 41.25 3.75 32.8553 3.75 22.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_905_2116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45C34.9264 45 45 34.9264 45 22.5ZM3.75 22.5C3.75 12.1447 12.1447 3.75 22.5 3.75C32.8553 3.75 41.25 12.1447 41.25 22.5C41.25 32.8553 32.8553 41.25 22.5 41.25C12.1447 41.25 3.75 32.8553 3.75 22.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_905_2116)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -86.25,
    y: -86.25,
    width: 352.5,
    height: 352.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_905_2116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -87,
    y: -87,
    width: 354,
    height: 354
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -86.25,
    y: -86.25,
    width: 352.5,
    height: 352.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_905_2116)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5688 22.8188L28.2563 21.0938C29.3231 20.025 30 18.525 30 16.875C30 12.7312 26.6438 9.375 22.5 9.375C18.3562 9.375 15 12.7312 15 16.875H18.75C18.75 14.8125 20.4375 13.125 22.5 13.125C24.5606 13.125 26.25 14.8125 26.25 16.875C26.25 17.9062 25.8375 18.8438 25.1437 19.5187L22.8188 21.8813C21.4688 23.25 20.625 25.125 20.625 27.1875V28.125H24.375C24.375 25.3125 25.2188 24.1875 26.5688 22.8188ZM24.375 31.875V35.625H20.625V31.875H24.375Z",
    fill: "#424B5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_905_2116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 15,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5688 22.8188L28.2563 21.0938C29.3231 20.025 30 18.525 30 16.875C30 12.7312 26.6438 9.375 22.5 9.375C18.3562 9.375 15 12.7312 15 16.875H18.75C18.75 14.8125 20.4375 13.125 22.5 13.125C24.5606 13.125 26.25 14.8125 26.25 16.875C26.25 17.9062 25.8375 18.8438 25.1437 19.5187L22.8188 21.8813C21.4688 23.25 20.625 25.125 20.625 27.1875V28.125H24.375C24.375 25.3125 25.2188 24.1875 26.5688 22.8188ZM24.375 31.875V35.625H20.625V31.875H24.375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_905_2116)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -86.25,
    y: -86.25,
    width: 352.5,
    height: 352.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_905_2116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -87,
    y: -87,
    width: 354,
    height: 354
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -86.25,
    y: -86.25,
    width: 352.5,
    height: 352.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_905_2116)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.94899cde2550debf8cf9a990af69e5bd.svg";
export { ForwardRef as ReactComponent };